module.exports = __webpack_public_path__ + "img/fa-regular-400.d2e53334.svg";